// Initial default template graph for a campaign routing flow
export const initialNodes = [
  {
    id: 'start-1',
    type: 'start',
    position: { x: 350, y: 50 },
    data: {
      label: 'Start Lead Ingestion',
      subtitle: 'Inbound campaign lead entry point',
    },
  },
  {
    id: 'route-1',
    type: 'route',
    position: { x: 350, y: 180 },
    data: {
      label: 'Primary Waterfall Routing',
      subtitle: 'Engine: Waterfall',
      engine: 'waterfall',
      buyer_set_id: 1,
    },
  },
  {
    id: 'condition-1',
    type: 'condition',
    position: { x: 350, y: 340 },
    data: {
      label: 'Lead Score Threshold',
      subtitle: 'Check if lead score > 50',
      field: 'score',
      cases: [
        {
          case_id: 'high_score',
          operator: 'gt',
          value: 50,
          label: 'Score > 50',
        },
      ],
    },
  },
  {
    id: 'end-1',
    type: 'end',
    position: { x: 180, y: 520 },
    data: {
      label: 'Accepted & Sold',
      subtitle: 'Primary buyer purchased lead',
    },
  },
  {
    id: 'end-2',
    type: 'end',
    position: { x: 520, y: 520 },
    data: {
      label: 'Unmatched / Fallback',
      subtitle: 'No winner found',
    },
  },
];

export const initialEdges = [
  {
    id: 'e-start-route',
    source: 'start-1',
    target: 'route-1',
    type: 'custom',
    animated: true,
  },
  {
    id: 'e-route-cond',
    source: 'route-1',
    target: 'condition-1',
    type: 'custom',
    animated: true,
  },
  {
    id: 'e-cond-end1',
    source: 'condition-1',
    sourceHandle: 'high_score',
    target: 'end-1',
    type: 'custom',
    label: 'High Score (> 50)',
    style: { stroke: 'var(--green)' },
  },
  {
    id: 'e-cond-end2',
    source: 'condition-1',
    sourceHandle: 'false',
    target: 'end-2',
    type: 'custom',
    label: 'Else (Score ≤ 50)',
    style: { stroke: 'var(--red)' },
  },
];

export const nodeCategories = [
  {
    id: 'entry',
    name: 'Flow Control',
    color: 'var(--amber)',
    bgColor: 'var(--amber-bg)',
    items: [
      {
        type: 'start',
        title: 'Start Block',
        subtitle: 'Campaign entry point (Required: 1)',
        icon: 'Zap',
      },
      {
        type: 'end',
        title: 'End Block',
        subtitle: 'Terminal routing exit point',
        icon: 'CheckCircle2',
      },
      {
        type: 'offerwall',
        title: 'Offerwall (Fallback)',
        subtitle: 'Fallback URL redirect terminal',
        redirect_url: 'https://offers.kickoffadvertising.com/wall?lead={lead_id}&sub={sub_id}',
        payout: 2.50,
        icon: 'ExternalLink',
      },
    ],
  },

  {
    id: 'routing',
    name: 'Engine Routing',
    color: 'var(--blue)',
    bgColor: 'var(--blue-bg)',
    items: [
      {
        type: 'route',
        title: 'Waterfall Route',
        subtitle: 'Sequential tier buyer matching',
        engine: 'waterfall',
        buyer_set_id: 1,
        icon: 'Compass',
      },
      {
        type: 'route',
        title: 'Auction Route',
        subtitle: 'Real-time highest bidder auction',
        engine: 'auction',
        buyer_set_id: 1,
        icon: 'Sparkles',
      },
      {
        type: 'route',
        title: 'Direct Route',
        subtitle: 'Direct single-buyer assignment',
        engine: 'direct',
        buyer_set_id: 1,
        icon: 'UserPlus',
      },
    ],
  },
  {
    id: 'conditions',
    name: 'Condition & Branching',
    color: 'var(--purple)',
    bgColor: 'var(--purple-bg)',
    items: [
      {
        type: 'condition',
        title: 'Lead Score Rule',
        subtitle: 'Branch by lead score threshold',
        field: 'score',
        cases: [{ case_id: 'gt_50', operator: 'gt', value: 50 }],
        icon: 'GitBranch',
      },
      {
        type: 'condition',
        title: 'Status Fallback Check',
        subtitle: 'Check if lead status is no_winner',
        field: 'status',
        cases: [{ case_id: 'is_no_winner', operator: 'equals', value: 'no_winner' }],
        icon: 'Filter',
      },
      {
        type: 'condition',
        title: 'Tier Level Filter',
        subtitle: 'Check lead tier level',
        field: 'tier',
        cases: [{ case_id: 'tier_a', operator: 'equals', value: 'TIER_1' }],
        icon: 'Building2',
      },
    ],
  },
  {
    id: 'probability',
    name: 'Traffic Split & Experiments',
    color: '#F59E0B',
    bgColor: 'rgba(245, 158, 11, 0.15)',
    items: [
      {
        type: 'probability',
        title: 'Probability Splitter',
        subtitle: 'Weighted % traffic distribution (e.g. 50/50)',
        branches: [
          { branch_id: 'branch_a', weight: 50, label: 'Variant A' },
          { branch_id: 'branch_b', weight: 50, label: 'Variant B' },
        ],
        icon: 'PieChart',
      },
      {
        type: 'probability',
        title: '3-Way Traffic Split (30/60/10)',
        subtitle: '3-way percentage split (30% / 60% / 10%)',
        branches: [
          { branch_id: 'variant_a', weight: 30, label: 'Variant A' },
          { branch_id: 'variant_b', weight: 60, label: 'Variant B' },
          { branch_id: 'variant_c', weight: 10, label: 'Variant C' },
        ],
        icon: 'Shuffle',
      },
    ],
  },
];
